import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-transfer',
  templateUrl: './confirm-transfer.component.html',
  styleUrls: ['./confirm-transfer.component.scss']
})
export class ConfirmTransferComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { facilitatorName: string, organizationName: string },
  ) {
  };
}
